import { ProfessionalService } from "./../services/models/mental_health/Professional";
const moduleProfessional = {
  namespaced: true,
  state: {
    professionals: [],
    loading: false,
    state: "active",
  },
  getters: {
    getProfessionals(state) {
      return state.professionals;
    },
    getLoading(state) {
      return state.loading;
    },
  },
  mutations: {
    loadProfessionals(state, professionals) {
      state.professionals = professionals;
    },
    setState(state, newState) {
      state.state = newState;
    },
  },
  actions: {
    async getProfessionals({ commit, state }) {
      state.loading = true;
      let user = await ProfessionalService.getByState(state.state);
      commit("loadProfessionals", user);
      state.loading = false;
    },
  },
};

export default moduleProfessional;
